import React from "react";
import back8 from "../../assets/images/back8.jpg";
import back2 from "../../assets/images/back2.jpg";
import back10 from "../../assets/images/back10.jpg";
import back11 from "../../assets/images/back11.jpg";
import back12 from "../../assets/images/back12.jpg";
import back13 from "../../assets/images/back13.JPG";
import back14 from "../../assets/images/back14.jpg";
import back15 from "../../assets/images/back15.jpg";
import back16 from "../../assets/images/back16.JPG";
import back17 from "../../assets/images/back17.jpg";
import back18 from "../../assets/images/back18.JPG";
import back1 from "../../assets/images/back1.jpg";
export function BottomGallery() {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {/* Repeat for each image set */}
      <div className="grid gap-4">
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back8}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back2}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back10}
            alt="gallery-photo"
          />
        </div>
      </div>
      
      <div className="grid gap-4">
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back11}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back12}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back13}
            alt="gallery-photo"
          />
        </div>
      </div>
      
      <div className="grid gap-4">
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back14}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back15}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back16}
            alt="gallery-photo"
          />
        </div>
      </div>
      
      <div className="grid gap-4">
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back17}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back18}
            alt="gallery-photo"
          />
        </div>
        <div>
          <img
            className="h-auto max-w-full rounded-lg object-cover object-center transition-transform duration-300 transform hover:scale-105"
            src={back1}
            alt="gallery-photo"
          />
        </div>
      </div>
    </div>
  );
}
